import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getStoryPublishResult: host + 'reportResult/getStoryPublishResult',//媒体发布数据（新闻网）
    // getWebsiteMedia: host + 'reportResult/getWebsiteMedia',//获取媒体列表
    getWebsiteMedia: host + 'media/getAll',//获取媒体列表
    getMediaStatisticsByMediaCode: host + 'mediaPublishedStatistics/getMediaStatisticsByMediaCode',//媒体发布数据（微信、微博、抖音、其他）
    getAllMediaStatistics: host + 'mediaPublishedStatistics/getAllMediaStatistics',//ALL媒体发布数据（微信、微博、抖音、其他）
};

export const getStoryPublishResult = (body, callBack) => {  //媒体发布数据（新闻网）
    request({url:Apis.getStoryPublishResult, body, callBack});
};
export const getWebsiteMedia = (body, callBack) => {  //获取媒体列表
    request({url:Apis.getWebsiteMedia, body, callBack});
};
export const getMediaStatisticsByMediaCode = (body, callBack) => {  //媒体发布数据（微信、微博、抖音、其他）
    request({url:Apis.getMediaStatisticsByMediaCode, body, callBack});
};
export const getAllMediaStatistics = (body, callBack) => {  //ALL媒体发布数据（微信、微博、抖音、其他）
    request({url:Apis.getAllMediaStatistics, body, callBack});
};